import { CaretRight } from "@phosphor-icons/react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import WorkspaceImage from "common/components/WorkspaceImage";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { Workspace } from "common/types";

interface WorkspaceItemProps {
  workspace: Workspace;
}

export default function WorkspaceItem({
  workspace: {
    id,
    name,
    accounts_count: accountsCount,
    rental_account_count,
    icon_url,
  },
}: WorkspaceItemProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const isSelected = workspaceId === id;

  return (
    <Link
      to={`/workspaces/${id}/home`}
      replace
      className={clsx(
        "group h-[52px] flex items-center gap-1.5 rounded-3xl border border-black-200 transition-[background] p-1.5",
        isSelected
          ? "border-purple-400"
          : "hover:bg-black-100 border-black-100",
      )}
    >
      <WorkspaceImage id={id} size="md" imageSrc={icon_url} />

      <div className="flex flex-col items-start gap-y-0.5">
        <span className="line-clamp-1 break-all text-left text-sm-bold">
          {name}
        </span>
        <span className="text-xs-medium text-black-500">
          {accountsCount
            ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
            : "No accounts"}
          <RenderIf condition={!!rental_account_count}>
            • {rental_account_count} avatar{rental_account_count > 1 ? "s" : ""}
          </RenderIf>
        </span>
      </div>

      {!isSelected && (
        <CaretRight className="ml-auto size-4 text-black-500 opacity-0 transition-opacity group-hover:opacity-100" />
      )}
    </Link>
  );
}
